<app-confirm-dialog></app-confirm-dialog>
<app-toast-notification></app-toast-notification>
<div class="container-fluid">
  <ng-container *ngIf="this.authWebService.authenticated">
    <div class="header-container">
      <div class="header">
        <div class="header-row">
          <div class="logo-wrap">
            <img
              class="image-11"
              src="../assets/newimg/image-11-86@2x.png"
              alt="CBRTA"
            />
            <img
              class="vector-3"
              src="../assets/newimg/vector-3-106@2x.png"
              alt="|"
            />
            <div class="overlap-group">
              <span style="color: #4262a8">
                Cross <span class="badge"> </span>
                <span style="font-weight: bold"> Easy</span>
                <p class="brought-to-you-by-cr opensans-normal-star-dust-9px">
                  <span class="opensans-normal-star-dust-9px"
                    >Brought to you by Cross-Border Road and Transport
                    Agency</span
                  >
                </p>
              </span>
              <div class="ellipse-1"></div>
            </div>
          </div>
          <div class="user-logo-wrap">
            <figure>
              <img
                class="personcropcircle"
                src="../assets/newimg/person-crop-circle-33@2x.png"
                alt="person.crop.circle"
              />
            </figure>
            <span style="width: 100%" *ngIf="this.authWebService.authenticated">
              <strong>
                <a
                  *ngIf="this.authWebService.authenticated"
                  href="#userSubMenu"
                  data-toggle="collapse"
                  aria-expanded="false"
                  class="dropdown-toggle spacer-x opensans-semi-bold-black-16px"
                  role="button"
                  aria-haspopup="true"
                >
                  {{ this.authWebService.userData?.User?.FirstName }}
                  {{ this.authWebService.userData?.User?.LastName }}
                  <span class="caret"></span>
                </a>
              </strong>
              <div class="menu-box">
                <ul
                  *ngIf="this.authWebService.authenticated"
                  class="collapse list-unstyled"
                  id="userSubMenu"
                >
                  <li>
                    <a class="inner menu-shd" [routerLink]="['/ammenduser']">
                      My Profile
                    </a>
                  </li>
                  <li>
                    <a
                      class="inner menu-shd"
                      (click)="this.authWebService.logout()"
                      style="cursor: pointer"
                    >
                      Sign out
                    </a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="horizontal-nav-container">
      <div class="nav-wrapper text-center justify-content-center">
        <side-menu></side-menu>
      </div>
    </div>
    <div class="wrapper"></div>
  </ng-container>
  <div *ngIf="!this.authWebService.authenticated">
    <router-outlet></router-outlet>
  </div>

  <main
    class="container-fluid main_content_wrapper"
    *ngIf="this.authWebService.authenticated"
  >
    <div
      class="p-3 mb-2 bg-danger text-white"
      *ngIf="this.signalrService.sub | async"
    >
      Your session will be terminated in
      {{ this.signalrService.sub | async }} seconds
    </div>
    <!-- [ngClass]="{'table-responsive':enableClass} -->
    <router-outlet></router-outlet>
  </main>
</div>

<footer
  style="margin: 0px; padding: 0px"
  *ngIf="this.authWebService.authenticated && routeDetials != 'details'"
>
  <div class="row" style="margin: 0px; padding: 0px">
    <div class="col-12" style="margin: 0px; padding: 0px">
      <footer-btn
        [ctrlData]="ctrlData"
        *ngIf="!utility.isView"
        class=""
      ></footer-btn>
    </div>
  </div>
</footer>

<div
  bsModal
  #childModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-child-name"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content bgd-c" style="border: none !important">
      <div class="modal-body" style="border: none !important">
        <p class="h5" style="color: white !important">You have been idle!</p>
        <small class="extra-clr ft-c"> {{ idleState }}</small
        ><br />
        <small
          class="text-small"
          style="color: white !important; font-size: 10px !important"
          >You may extend your session.</small
        >
        <div
          style="
            border: none !important;
            height: 20px !important;
            margin-top: 5px !important;
          "
        >
          <button
            type="button"
            class="btn btn-danger btn-sm pull-right"
            style="margin-right: 4px !important; width: 60px !important"
            (click)="logout()"
          >
            Leave
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm pull-right"
            style="
              margin-right: 4px !important;
              padding-right: 4px !important;
              width: 60px !important;
            "
            (click)="stay()"
          >
            Stay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<script src="https://apis.google.com/js/platform.js" async defer></script>
